// extracted by mini-css-extract-plugin
export default {"pillsWrapper":"PillsCell_pillsWrapper__piAeo","more":"PillsCell_more__gSkAp","visible":"PillsCell_visible__0jnlu"};